import { Table } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../service";
import {  OrganizationContactPerson } from "../../../utils/Constant";

const InvoiceThreeHeader = ({orgData}:any) => {
    console.log(orgData,"1234")
 return (
    <td>
      <Table borderless style={{ width: "100%", backgroundImage: `url(${dynamicImage(`email-template/invoice-3/bg-0.png`)})`, backgroundPosition: "center", backgroundSize: "cover", backgroundRepeat: "no-repeat", borderRadius: 10 }} >
        <tbody>
          <tr>
            <td style={{ padding: "30px 0 30px 0" }}>
              <Image className="for-light" src={dynamicImage(orgData?.image)} alt="logo" style={{width:"100px",height:"60px",paddingLeft:"1rem"}}/>
              <Image className="for-dark" src={dynamicImage("logo/logo.png")} alt="logo" />
              <address style={{ opacity: "0.8", width: "36%", marginTop: 10, fontStyle: "normal" }}>
                <span style={{ fontSize: 18, lineHeight: "1.5", fontWeight: 500 ,paddingLeft:"1rem"}} >
                  {orgData?.address}
                </span>
              </address>
            </td>
            <td style={{ textAlign: "end", padding: "30px 30px 30px 0" }}>
              <span style={{ display: "block", lineHeight: "1.5", fontSize: 18, color: "#fff", fontWeight: 700 }}>
                {OrganizationContactPerson}
              </span>
              <span style={{ display: "block", lineHeight: "1.5", fontSize: 18, color: "#fff", fontWeight: 500 }} >
                {orgData?.contactPerson}
              </span>
              <span style={{ display: "block", lineHeight: "1.5", fontSize: 18, color: "#fff", fontWeight: 500 }} >
               {orgData?.email}
              </span>
              <span style={{ display: "block", lineHeight: "1.5", fontSize: 18, color: "#fff", fontWeight: 500 }} >
               {orgData?.mobileNumber}
              </span>
            </td>
          </tr>
        </tbody>
      </Table>
    </td>
  );
};

export default InvoiceThreeHeader;
